import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=1cbc23be&scoped=true&"
import script from "./DashboardContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardContainer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContainer.vue?vue&type=style&index=0&id=1cbc23be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc23be",
  null
  
)

export default component.exports